import { CommunicationMethodMagicLink } from './communication-method-magic-link.enum';

export enum InviteOpenAcceptSource {
  SmsInviteLink = 'sms_invite_link',
  EmailInviteLink = 'email_invite_link',
  WhatsappInviteLink = 'whatsapp_invite_link',
  SameSession = 'same_session',
  Other = 'other',
  MagicLink = 'magic_link',
  Rcs = 'rcs',
}

export const INVITE_SOURCE_BY_COMMUNICATION_METHOD: { [key in CommunicationMethodMagicLink]?: InviteOpenAcceptSource } = {
  [CommunicationMethodMagicLink.Email]: InviteOpenAcceptSource.EmailInviteLink,
  [CommunicationMethodMagicLink.Manual]: InviteOpenAcceptSource.MagicLink,
  [CommunicationMethodMagicLink.Sms]: InviteOpenAcceptSource.SmsInviteLink,
  [CommunicationMethodMagicLink.Whatsapp]: InviteOpenAcceptSource.WhatsappInviteLink,
  [CommunicationMethodMagicLink.Rcs]: InviteOpenAcceptSource.Rcs,
};
